"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _config = _interopRequireDefault(require("../../../config"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var OverrideService = /*#__PURE__*/function () {
  function OverrideService() {
    _classCallCheck(this, OverrideService);
  }

  _createClass(OverrideService, null, [{
    key: "storeConfiguration",

    /**
     * Refresh auth
     */
    value: function storeConfiguration(configuration) {
      this.configuration = configuration;

      _config["default"].merge(this.getConfig());
    }
    /**
     * Gt all overrides
     */

  }, {
    key: "getOverrides",
    value: function getOverrides() {
      return this.configuration && this.configuration.overrides ? this.configuration.overrides : null;
    }
    /**
     * Get config
     */

  }, {
    key: "getConfig",
    value: function getConfig() {
      return this.configuration && this.configuration.config ? this.configuration.config : {};
    }
    /**
     * Get routes
     */

  }, {
    key: "getRoutes",
    value: function getRoutes() {
      return _lodash["default"].get(this.configuration, 'routes', []);
    }
    /**
     * Get side navigation
     *
     * @param appNavigation Actual app navigation
     */

  }, {
    key: "getSideNavigation",
    value: function getSideNavigation(appNavigation) {
      var alterFunction = _lodash["default"].get(this.configuration, 'getNavigation', null);

      if (alterFunction) {
        return alterFunction(appNavigation);
      }

      return appNavigation;
    }
  }, {
    key: "thisOrOverridenComponent",
    value: function thisOrOverridenComponent(OriginalComponent, overridePath) {
      var SelectedButton = function SelectedButton(props) {
        if (_lodash["default"].get(OverrideService.getOverrides(), overridePath)) {
          var CustomButton = _lodash["default"].get(OverrideService.getOverrides(), overridePath);

          return _react["default"].createElement(CustomButton, props);
        }

        return _react["default"].createElement(OriginalComponent, props);
      };

      return SelectedButton;
    } // static getThisOrOverridenColors() {
    //   if (OverrideService.getStyles() && OverrideService.getStyles().colors) {
    //     return {
    //       ...colors,
    //       ...OverrideService.getStyles().colors
    //     };
    //   }
    //   return {
    //     ...colors
    //   };
    // }

  }]);

  return OverrideService;
}();

exports["default"] = OverrideService;

_defineProperty(OverrideService, "configuration", void 0);

_defineProperty(OverrideService, "overrides", void 0);